
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"81","height":"80","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#71D3B9","d":"M41.229 4l29.107 14.063 7.189 31.6-20.143 25.34H25.076L4.933 49.664l7.19-31.6z"}}),_c('path',{attrs:{"fill":"#0A294A","d":"M27.487 13.567l26.667-.133 16.73 20.834-5.804 26.114L41.11 72.11 17.028 60.622l-6.064-26.054z"}}),_c('path',{attrs:{"d":"M41 26l4.243 1.757L47 32l-1.757 4.243L42 37.586v8.353h4.977l1.187 1.828h3.909l1.24 1.357v3.749H29v-3.75l1.24-1.356h3.909l1.187-1.828H40v-8.353l-3.243-1.343L35 32l1.757-4.243L41 26zm-8 20v1h-2v-1h2z","fill":"#FFF"}})])])
          )
        }
      }
    